<template>
  <el-table
    :data="data"
    :default-sort="defaultSort"
    :size="size"
  >
    <el-table-column label="User email" prop="userEmail" sortable />

    <el-table-column label="Date" prop="created" sortable>
      <template slot-scope="scope">
        {{ toCalendar(scope.row.created) }}
      </template>
    </el-table-column>

    <el-table-column label="Ip Address" prop="userIp" sortable />

    <el-table-column
      v-if="name === ''"
      label="Action"
      prop="name"
      sortable
    />
  </el-table>
</template>

<script>
export default {
  props: {
    name: String,
    instanceId: String,
    applicationName: String,
    size: {
      type: String,
      default: 'small'
    }
  },
  created () {
    this.load()
  },
  data () {
    return {
      data: [],
      defaultSort: {
        prop: 'created',
        order: 'descending'
      }
    }
  },
  methods: {
    load () {
      this.$store.dispatch('getProjectActions', this.name).then((actions) => {
        this.data = actions
      }).catch(() => {})
    }
  }
}
</script>
